sentryBrowserConfig();
import { sentryBrowserConfig } from "../sentry.browser.config";

// Custom tracking
window.addEventListener("error", (err) => {
  console.error("An error occurred:", err);
});
